import { render, staticRenderFns } from "./CandidateBigSliderItem.vue?vue&type=template&id=76ec3861&scoped=true&"
import script from "./CandidateBigSliderItem.vue?vue&type=script&lang=js&"
export * from "./CandidateBigSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateBigSliderItem.vue?vue&type=style&index=0&id=76ec3861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec3861",
  null
  
)

/* custom blocks */
import block0 from "./CandidateBigSliderItem.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateBigSliderItem.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardTitle,VChip})
